<template>
	<div class="flex flex-row min-h-screen max-w-full" id="top">
		<sidebar> </sidebar>
		<div class="flex-1 max-w-full min-w-0 bg-gray-100" id="main-content">
			<div class="flex flex-col min-h-full align-middle max-w-full">
				<div style="height: 1.75em" class="flex flex-row justify-between px-4 text-3xl logo-area sticky top-0 z-50 bg-gray-100">
					<div class="justify-items-left flex items-center">
						<!-- <img src="/ERM_EcoDesign-Horizontal-White-Header.svg" class="h-11 object-scale-down object-center md:h-7" />&nbsp; -->
						<div
							v-if="themeStore.getCurrentTheme.templateUI?.menulogoImageBinary && themeStore.getCurrentTheme.templateUI?.menulogoImageContentType"
							v-html="
								createImageFromBinary(
									themeStore.getCurrentTheme.templateUI?.menulogoImageBinary,
									themeStore.getCurrentTheme.templateUI?.menulogoImageContentType
								)
							"
							class="h-full py-1 default-logo"
							style="max-height: 100%"
						></div>
						<img v-else src="/ERM_EcoDesign-Horizontal-White-Header.svg" class="h-full py-1 default-logo" style="max-height: 1.5em" />
					</div>

					<div class="flex items-center gap-4">
						<div class="flex flex-row justify-items-center gap-2 text-xl" v-if="apiCount > 0">
							Loading
							<ProgressBar style="display: flex; width: 70px" mode="indeterminate" />
						</div>
						<Button @click="openFeedback()" class="text-xs"><FontAwesomeIcon :icon="['far', 'comment-minus']" size="lg" class="mr-2" />Feedback</Button>
						<Button @click="openLCALiteSharepoint()" class="text-xs"><FontAwesomeIcon :icon="['far', 'link']" size="lg" class="mr-2" />LCA Lite Sharepoint</Button>
						<div class="justify-items-right flex flex-row gap-1 text-xs">
							<SplitButton ref="splitButtonRef" :label="UserName" icon="pi pi-user" :model="itemsM" @click="openUserSplitButtonMenu"> </SplitButton>
						</div>
					</div>
				</div>
				<main role="main">
					<breadcrumb />
					<router-view :key="$route.fullPath"></router-view>
				</main>
			</div>
		</div>
	</div>

	<Drawer
		position="right"
		style="width: 40em; max-width: 40vw"
		v-model:visible="showHelp"
		@hide="closeHelp"
		:showCloseIcon="false"
		:baseZIndex="1000"
	>
		<div class="flex flex-col gap-4 mb-4">
			<div class="flex flex-row-reverse justify-between">
				<button aria-label="Close Help" @click="showHelp = false">
					<FontAwesomeIcon class="text-redSignal largeheader" :icon="['far', 'circle-xmark']" />
				</button>
				<h1>{{ userFriendlyName }}</h1>
			</div>
		</div>
		<div class="help-content" v-html="helpContent" />
	</Drawer>
	<Dialog :header="dialogContent.header" class="i2Dialog" position="top" v-model:visible="showDialog" style="min-width: 33vw">
		{{ dialogContent.content }}
	</Dialog>
	<Toast position="top-right" @close="handleToastClose">
		<template #message="slotProps">
			<div class="flex flex-col gap-2 w-full">
				<span class="font-bold">{{ slotProps.message.summary }}</span>
				<span v-html="slotProps.message.detail" style="white-space: pre-line"></span>
			</div>
		</template>
	</Toast>
	<DynamicDialog />
	<!--GS start-->
	<Dialog header="Log in" class="i2Dialog" position="top" v-model:visible="showLoginDialog" style="min-width: 33vw"> </Dialog>
	<!--GS end-->

	<ConfirmDialog></ConfirmDialog>
	<ReAuthModal />
</template>

<script setup lang="ts">
import { nextTick, ref, onMounted } from "vue"
import ConfirmDialog from "primevue/confirmdialog"
import ReAuthModal from "./ReAuthModal.vue"
import sidebar from "./sidebar.vue"
import { EventBus } from "../eventBus"
import ProgressBar from "primevue/progressbar"
import Drawer from "primevue/drawer"
import Button from "primevue/button"
import SplitButton from "primevue/splitbutton"
import { ApiClient, HelpPage, ThemeMgmClient, TemplateUI } from "../../entities/NSwagGenerated"
// TODO: Uncomment when TypeScript is updated: UserThemeSelectionClient
import { useThemeManagerStore } from "../store/themeManagerStore"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faCircleXmark } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { useEnvironmentSettings } from "../composables/environmentSettings"
import * as Session from "../auth/personSessionData"
import breadcrumb from "./breadcrumb.vue"
library.add(faCircleXmark)
import Dialog from "primevue/dialog"
import DialogContent from "../models"
import { authProvider } from "../auth/authProviderFactory"
import Toast, { ToastMessageOptions } from "primevue/toast"
import { useToast } from "primevue/usetoast"

const toast = useToast()


let handleToastClose = () => {}

//let apiCount: number = 0
const apiCount = ref(0)
const showHelp = ref(false)
const helpContent = ref()
const userFriendlyName = ref()
const helpPageName = ref()
const dialogContent = new DialogContent()
const showDialog = ref(false)
const showLoginDialog = ref(false)
const environmentSettings = useEnvironmentSettings()
const environmentName: string = ""
const apiClient = new ApiClient(import.meta.env.VITE_API_URL?.toString())
const themeMgmClient = new ThemeMgmClient(import.meta.env.VITE_API_URL?.toString())
// TODO: Uncomment when TypeScript is updated
// const userThemeSelectionClient = new UserThemeSelectionClient(import.meta.env.VITE_API_URL?.toString())
const themeStore = useThemeManagerStore()
const UserName = ref()
const closeHelp = ref()
const availableThemes = ref<TemplateUI[]>([])
const currentThemeId = ref<string | null>(null)

const splitButtonRef = ref<InstanceType<typeof SplitButton> | null>(null)

type MenuItem = {
	label: string
	icon: string
	command?: () => void
	items?: MenuItem[]
}
// Function to create image HTML from binary data
const createImageFromBinary = (binaryData: string, contentType: string): string => {
	if (!binaryData) return ""

	// Check if binaryData is already a data URL
	if (binaryData.startsWith("data:")) {
		return `<img src="${binaryData}" alt="Image" style="max-width: 100%; max-height: 1.5em; height: auto; width: auto; object-fit: contain; background: transparent;" class="transparent-image header-logo-img" />`
	}

	// Handle SVG files specially
	if (contentType === "image/svg+xml" || contentType.includes("svg")) {
		// For SVG, try to decode as text first
		try {
			const svgContent = atob(binaryData)
			// If it's valid SVG content, return it with size constraints
			if (svgContent.includes("<svg")) {
				// Add viewBox and size constraints to SVG
				const modifiedSvg = svgContent.replace(
					/<svg([^>]*)>/,
					'<svg$1 style="max-width: 100%; max-height: 1.5em; height: auto; width: auto; object-fit: contain;" class="header-logo-svg">'
				)
				return modifiedSvg
			}
		} catch (error) {
			// If decoding fails, fall back to data URL
			console.log("SVG decode failed, using data URL:", error)
		}
	}

	// Check if binaryData is already base64 encoded
	let base64Data = binaryData
	if (!binaryData.startsWith("/9j") && !binaryData.startsWith("iVBOR") && !binaryData.startsWith("R0lGOD") && !binaryData.startsWith("PHN2Zw")) {
		// If not base64, assume it's already binary and convert to base64
		try {
			base64Data = btoa(binaryData)
		} catch (error) {
			console.error("Error encoding binary data to base64:", error)
			return ""
		}
	}

	const dataUrl = `data:${contentType};base64,${base64Data}`
	return `<img src="${dataUrl}" alt="Image" style="max-width: 100%; max-height: 1.5em; height: auto; width: auto; object-fit: contain; background: transparent;" class="transparent-image header-logo-img" />`
}
function openFeedback() {
	window.open("https://app.smartsheet.com/b/form/42dc1f1c6a73406382b7962d787f0faf", "_blank")
}

const openUserSplitButtonMenu = async () => {
	await nextTick()
	const el = (splitButtonRef.value as any)?.$el as HTMLElement
	const menuButton = el?.querySelector(".p-splitbutton-menubutton")
	if (menuButton instanceof HTMLElement) {
		menuButton.click()
	}
}

const loadAvailableThemes = async () => {
	try {
		// TODO: Replace with userThemeSelectionClient.getAvailableThemes() when TypeScript is updated
		const themes = await themeMgmClient.getAllThemes()
		availableThemes.value = themes
		updateMenuItems()
	} catch (error) {
		console.error("Error loading themes:", error)
	}
}

const applyTheme = async (themeId: string) => {
	try {
		// Save the user's theme selection to the database (temporary fetch implementation)
		const saveResponse = await fetch(`${import.meta.env.VITE_API_URL}/api/userThemeSelection/saveUserThemeSelection`, {
			method: "POST",
			headers: {
				Authorization: `Bearer ${localStorage.getItem("token")}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify(themeId),
		})

		if (!saveResponse.ok) {
			throw new Error("Failed to save theme selection")
		}

		// Apply the theme to the interface
		await themeStore.loadSingleCompleteTemplate(themeId, "live")

		// Update current theme and refresh menu
		currentThemeId.value = themeId
		await updateMenuItems()

		// Show success message
		toast.add({
			severity: "success",
			summary: "Theme Applied",
			detail: "Your theme selection has been saved successfully",
			life: 3000,
		})
	} catch (error) {
		console.error("Error applying theme:", error)
		toast.add({
			severity: "error",
			summary: "Theme Error",
			detail: "Failed to apply the selected theme",
			life: 5000,
		})
	}
}

const loadUserTheme = async () => {
	try {
		console.log("🔍 Loading user theme...")
		const token = localStorage.getItem("token")
		console.log("🔑 Token available:", !!token)

		// Temporary implementation using fetch API until TypeScript is updated
		const response = await fetch(`${import.meta.env.VITE_API_URL}/api/userThemeSelection/getCurrentUserTheme`, {
			method: "GET",
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			},
		})

		console.log("📡 API Response status:", response.status)

		if (response.ok) {
			const userTheme = await response.json()
			console.log("🎨 User theme data:", userTheme)

			if (userTheme && userTheme.selectedTheme && userTheme.selectedTheme.id) {
				console.log("✅ Applying user theme:", userTheme.selectedTheme.templateName, userTheme.selectedTheme.id)

				// Apply the user's theme (this will also save the default theme association if needed)
				await themeStore.loadSingleCompleteTemplate(userTheme.selectedTheme.id, "live")
				currentThemeId.value = userTheme.selectedTheme.id
				await updateMenuItems() // Update menu to show selected theme
				console.log("🎯 User theme applied successfully!")
			} else {
				console.log("⚠️ No valid theme data in response")
			}
		} else {
			const errorText = await response.text()
			console.log("❌ API Error:", response.status, errorText)
		}
	} catch (error) {
		console.error("💥 Error loading user theme:", error)
		// If there's an error, the app will continue with the default theme
	}
}

const itemsM = ref<MenuItem[]>([
	{
		label: "Log out",
		icon: "pi pi-times",
		command: () => {
			logOff()
		},
	},
])

const updateMenuItems = async (forceReload = false) => {
	// Reload themes if requested or if theme list is empty
	if (forceReload || availableThemes.value.length === 0) {
		try {
			const themes = await themeMgmClient.getAllThemes()
			availableThemes.value = themes
		} catch (error) {
			console.error("Error reloading themes:", error)
		}
	}

	// Filter themes to show only active non-standard themes
	const filteredThemes = availableThemes.value.filter((theme) => theme.isActive === true && theme.isStandardTheme === false)

	itemsM.value = [
		{
			label: "Theme",
			icon: "pi pi-palette",
			command: async () => {
				// Reload themes when Theme menu is clicked
				await updateMenuItems(true)
			},
			items: filteredThemes.map((theme) => ({
				label: theme.templateName || "Unnamed Theme",
				icon: theme.id === currentThemeId.value ? "pi pi-check-circle" : "pi pi-circle",
				command: () => {
					if (theme.id) {
						applyTheme(theme.id)
					}
				},
			})),
		},
		{
			label: "Log out",
			icon: "pi pi-times",
			command: () => {
				logOff()
			},
		},
	]
}
const webPath = window.location.protocol + "//" + window.location.host

onMounted(async () => {
	UserName.value = Session.SessionInfo.currentUser().firstName
	await loadAvailableThemes()

	// Theme is now loaded by route guard before this component mounts
	// Update currentThemeId based on already loaded theme
	if (themeStore.getCurrentTheme?.templateUI?.id) {
		currentThemeId.value = themeStore.getCurrentTheme.templateUI.id
		await updateMenuItems()
	}
	EventBus.on("IncrementApiCalls", () => {
		apiCount.value++
	})
	EventBus.on("systemToast", (options: any) => {
		if (options.callback) {
			handleToastClose = options.callback
			console.log("handleToastClose", handleToastClose)
		} else {
			handleToastClose = () => {}
		}

		toast.add(options)
	})

	EventBus.on("ZeroApiCalls", () => {
		apiCount.value = 0
	})

	EventBus.on("ShowDialog", (dialogContent) => {
		dialogContent = JSON.parse(JSON.stringify(dialogContent))
		showDialog.value = true
	})

	EventBus.on("ShowLoginDialog", (dialogContent) => {})

	EventBus.on("DecrementApiCalls", () => {
		if (apiCount.value > 0) {
			apiCount.value--
		}
	})

	EventBus.on("APIError", (err: any) => {
		if (err.status == 204) {
			helpContent.value = `No help configuration for Help Page Name "${helpPageName}"`
		} else {
			helpContent.value = err.message
		}
	})

	EventBus.on("OpenPageHelp", (helpPageData: any) => {
		userFriendlyName.value = helpPageData.userFriendlyName
		helpPageName.value = helpPageData.helpPageName
		apiClient
			.getHelpPageByName(helpPageData.helpPageName)
			.then(
				(res) => {
					if (res) {
						helpContent.value = res.helpContent || "No Help Found"
						userFriendlyName.value = res.userFriendlyName || helpPageData.userFriendlyName
					} else {
						helpContent.value = `No help configuration for Help Page Name "${helpPageData.helpPageName}"`
					}
				},
				(err) => {
					console.log(err)
				}
			)
			.finally(() => {
				showHelp.value = true
			})
	})
})

function openLCALiteSharepoint() {
	window.open("https://azcollaboration.sharepoint.com/sites/CMU473/SitePages/LCA-Lite.aspx", "_blank")
}

// function logOff() {
// }

const logOff = async () => {
	try {
		await authProvider.signOut()
	} catch (error) {
		console.error("Logout failed", error)
		// Even if logout fails, clear local data and redirect
		authProvider.clearTokens()
		window.location.href = "/login"
	}
}
</script>

<style scoped>
.colorWhite {
	color: #ffffff !important;
}
::v-deep(.p-dialog-header) {
	background: var(--p-dialog-title-background, var(--p-ermbrand-green-1)) !important;
	color: var(--p-dialog-title-color, #ffffff) !important;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}
.logo-area {
	color: var(--p-menu-up-text-color);
	border-bottom: 0.2em solid var(--p-menu-up-border-bottom);
	background-color: var(--p-menu-up-background-color);
}
.logo-area :deep(button:not(.color-picker-btn)) {
	background-color: var(--p-menu-up-button-color, #007bff) !important;
	color: var(--p-menu-up-button-text-color, white) !important;
	border-color: var(--p-menu-up-button-color, #007bff) !important;
}
.default-logo {
	height: 100%;
	display: flex;
	align-items: center;
}
.default-logo :deep(img) {
	height: 100%;
	width: auto;
	object-fit: contain;
}

/* Restore list styles stripped by Tailwind preflight inside help content */
.help-content :deep(ol) {
	list-style-type: decimal;
	padding-left: 1.5em;
}
.help-content :deep(ul) {
	list-style-type: disc;
	padding-left: 1.5em;
}
.help-content :deep(ol ol) {
	list-style-type: lower-alpha;
}
.help-content :deep(ol ol ol) {
	list-style-type: lower-roman;
}
</style>
